import {
  FilterSearchSpecificFilterFnKey,
  TokenStatus,
} from '@/common/components/molecules/filterSearch/filterSearch.type';
import {
  normalizeAgeToSeconds,
  stringToBps,
  stringToBytes,
  stringToMiB,
  stringToMs,
  stringToW,
} from '@/common/components/molecules/filterSearch/filterSearch.specificFilterFunctions';

export const LOGICAL_OPERATORS = [
  {
    name: 'OR',
    value: 'OR',
  },
  {
    name: 'AND',
    value: 'AND',
  },
] as const;

export const TOKEN_STATUS: Record<TokenStatus, TokenStatus> = {
  EMPTY: 'EMPTY',
  KEY_ING: 'KEY_ING',
  KEY_DONE: 'KEY_DONE',
  OPERATOR_ING: 'OPERATOR_ING',
  OPERATOR_DONE: 'OPERATOR_DONE',
  VALUE_ING: 'VALUE_ING',
  VALUE_DONE: 'VALUE_DONE',
} as const;

export const MAXIMUM_HISTORY_SIZE = 5;
export const MAXIMUM_STORED_HISTORY_SIZE = 20;

export const FILTER_SEARCH_OPERATORS = [
  'like',
  'not like',
  '==',
  '!=',
  '>',
  '>=',
  '<',
  '<=',
] as const;

export const FILTER_SEARCH_OPERATORS_BY_SPECIFIC_FILTER_FN: {
  [key in FilterSearchSpecificFilterFnKey]: 'string' | 'number' | 'boolean';
} = {
  toMs: 'number',
  toBytes: 'number',
  toKiB: 'number',
  toMB: 'number',
  readableBytes: 'number',
  rendererTypeSec: 'number',
  toSecByUnit: 'number',
  toBps: 'number',
  mWToW: 'number',
  bytesToMiB: 'number',
  toUnixTime: 'number',
  age: 'number',
};

export const FILTER_SEARCH_TOKEN_VALUE_CONVERTERS_BY_SPECIFIC_FILTER_FN: {
  [key in FilterSearchSpecificFilterFnKey]?: (
    targetValue: string,
    defaultUnit?: string,
  ) => number | undefined;
} = {
  toMs: stringToMs,
  toBytes: stringToBytes,
  toKiB: (v) => stringToBytes(v, 'KiB'),
  toMB: (v) => stringToBytes(v, 'MB'),
  rendererTypeSec: (v) => stringToMs(v, 's'),
  toSecByUnit: (v) => stringToMs(v, 's'),
  toBps: stringToBps,
  mWToW: stringToW,
  bytesToMiB: stringToMiB,
  age: normalizeAgeToSeconds,
};

export const AGE_UNITS = {
  s: 1,
  m: 60,
  h: 3600,
  d: 86400,
  M: 2592000,
  y: 31536000,
} as const;

export type AgeUnit = keyof typeof AGE_UNITS;
